// Get all cards with modals
const modals = document.querySelectorAll('.modals .modal');
const modalBackground = document.querySelector('.modals__background');
loadModals(modals);

function loadModals(modals) {
    modals.forEach(modal => {
        let modalItem = modal.querySelector('.modal__item'); 
        let showBtn = modal.querySelector('.modal__button-open');
        let closeBtn = modal.querySelector('.modal__button-close');
        showBtn.addEventListener('click', function(event) {
            event.preventDefault();
            // If not currently expanded
            if(showBtn.getAttribute('aria-expanded') == 'false') {
                modalItem.removeAttribute('hidden');
                showBtn.setAttribute('aria-expanded', 'true');
                closeBtn.setAttribute('aria-expanded', 'true');
                toggleModalOverlay();
            }
        });
        closeBtn.addEventListener('click', function(event) {
            event.preventDefault();
            // If currently expanded
            if(closeBtn.getAttribute('aria-expanded') == 'true') {
                modalItem.setAttribute('hidden', '');
                showBtn.setAttribute('aria-expanded', 'false');
                closeBtn.setAttribute('aria-expanded', 'false');
                toggleModalOverlay(false);
            }
        });
    });
}

function toggleModalOverlay(active = true) {
    if(active) {
        document.body.classList.add('noScroll');
        modalBackground.classList.add('active');
    } else {
        document.body.classList.remove('noScroll');
        modalBackground.classList.remove('active');
    }
}

if(modalBackground) {
    modalBackground.addEventListener('click', function(event) {
        if(this.classList.contains('active')) {
            modals.forEach(modal => {
                let showBtn = modal.querySelector('.modal__button-open');
                let closeBtn = modal.querySelector('.modal__button-close');
                if(showBtn.getAttribute('aria-expanded') == 'true') {
                    modal.querySelector('.modal__item').setAttribute('hidden', '');
                    showBtn.setAttribute('aria-expanded', 'false');
                    closeBtn.setAttribute('aria-expanded', 'false');
                    toggleModalOverlay(false);
                }
            });
        }
    });
}